import AddIcon from '@mui/icons-material/Add';
import { Button, Typography } from '@mui/material';
import type { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetTenants } from '../../../lib/query/manageTenants';

const columns: GridColDef[] = [
  { field: 'RowKey', headerName: 'Tenant Name', flex: 1 },
  { field: 'CompanyLicenses', headerName: 'Company Licenses', width: 180 },
  { field: 'Email', headerName: 'Email', flex: 1 },
  { field: 'IsActive', headerName: 'Active', width: 100, type: 'boolean' },
  { field: 'CreatedOn', headerName: 'Created On', width: 180 },
];

const CustomToolbar = () => (
  <GridToolbarContainer style={{ justifyContent: 'space-between' }}>
    <GridToolbarQuickFilter />
  </GridToolbarContainer>
);

const ManageTenants = () => {
  const navigate = useNavigate();
  const { data: tenants, isLoading } = useGetTenants();
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });

  return (
    <div className="mt-4">
      <Typography variant="h4" sx={{ color: 'black', fontWeight: '600' }}>
        Manage Tenants
      </Typography>

      <div className="flex py-4 justify-end">
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          size="small"
          onClick={() => navigate('/super-admin/new-tenant')}
        >
          Add New
        </Button>
      </div>

      <DataGrid
        rows={tenants ?? []}
        columns={columns}
        getRowId={row => row.id ?? row.RowKey}
        slots={{ toolbar: CustomToolbar }}
        loading={isLoading}
        autoHeight
        pageSizeOptions={[5, 10, 20]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        sx={{
          boxShadow: 2,
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: '700',
            color: '#020617',
          },
        }}
      />
    </div>
  );
};

export default ManageTenants;
